import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";

const DetalleFacturaCard = ({ totalNeto, ivaCalculado, percepciones, totalFinal, preFactura }) => {
  const mostrarPercepciones = percepciones !== null && percepciones > 0;
  
  return (
    <Paper sx={{ 
      p: 1,
      bgcolor: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: 1,
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <ReceiptIcon sx={{ fontSize: 16, color: "#757575" }} />
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            DETALLE FACTURA
          </Typography>
        </Box>
        {preFactura?.factura?.CantReg > 1 && (
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
            {preFactura.factura.CantReg} docs
          </Typography>
        )}
      </Box>

      {/* Contenido principal */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        {/* Montos en grid compacto */}
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={0.5}>
          <Typography variant="caption" color="text.secondary">Neto:</Typography>
          <Typography variant="caption" textAlign="right" fontFamily="monospace">
            ${totalNeto.toFixed(2)}
          </Typography>
          
          <Typography variant="caption" color="text.secondary">IVA:</Typography>
          <Typography variant="caption" textAlign="right" fontFamily="monospace">
            ${ivaCalculado.toFixed(2)}
          </Typography>
          
          {mostrarPercepciones && (
            <>
              <Typography variant="caption" color="text.secondary">Percep.:</Typography>
              <Typography variant="caption" textAlign="right" fontFamily="monospace">
                ${parseFloat(percepciones).toFixed(2)}
              </Typography>
            </>
          )}
        </Box>
      </Box>

      {/* Total destacado */}
      <Box 
        sx={{ 
          mt: 'auto',
          pt: 0.5, 
          borderTop: '1px solid #e0e0e0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="caption" fontWeight="bold" color="text.primary">
          TOTAL:
        </Typography>
        <Typography variant="subtitle2" fontWeight="bold" color="primary">
          ${totalFinal.toFixed(2)}
        </Typography>
      </Box>
    </Paper>
  );
};

export default DetalleFacturaCard;